import { App } from '@grafikr/components';

import './css/app.css';
import 'vendor/lazysizes';

import Bugsnag from '@bugsnag/js';

import components from 'framework/components';
import state from 'framework/state';

const app = new App();

components(app);
state(app);
app.mount();

document.addEventListener('shopify:section:load', ({ detail }) => {
  const section = document.getElementById(`shopify-section-${detail.sectionId}`);

  if (section) {
    app.mount(section);
  }
});

Bugsnag.start({
  apiKey: '8ca938646754ed917145e8a420239493',
  enabledReleaseStages: ['production'],
  releaseStage: process.env.NODE_ENV === 'production' ? 'production' : 'development',
  collectUserIp: false,
});
